import axios from "@/api/axios"

class Api {
  constructor() {
    this.socket = null
    this.reconnectInterval = 15000
  }

  _init = async () => {
    //document.getElementById("viewport").setAttribute("content", "width=1280, initial-scale=1.5")

    await this.loadResources()
    await _$.sleep(2000)
    await this.makeConfigurations()

    this.addListeners()

    tizen.tvwindow.hide(() => {}, null, "MAIN")

    _$.vue.$on("ready", () => {
      this.initSocket().then(() => (this.socket.onmessage = event => _$.handler.emit({ type: "data_received", detail: event })))
      this.tokenRequest()
    })
    return true
  }

  addListeners = () => {
    document.addEventListener("visibilitychange", _$.handler.emit, false)

    _$.vue.$on("mediaPlaying", () => !__.device.isPowerOn() && __.media.stop().then(() => __.media.request(true)))

    _$.vue.$on("standBy", () => __.platform.go().then(() => __.media.request(true)))
    _$.vue.$on("powerOn", () => __.media.request())

    return true
  }
  makeConfigurations = async () => {
    webapis.systemcontrol.deleteAppPrivateInfo("OFF")
    webapis.avplay._setDisplayRects(0, 0, 1920, 1080, false)
    tizen.tvwindow.hide(() => {}, null, "MAIN")

    return true
  }
  loadResources = async () => {}
  checkOut() {
    _$.sleep(3000).then(() => __.device.reboot())
  }
  async tokenRequest() {
    if (__.device.get("tizen_token")) return

    const res = await axios()
      .post("/api/send/tizen65/token", { ip: __.device.properties.ip, mac: __.device.properties.mac })
      .catch(err => _$.error(err))

    if (!res) return window.setTimeout(() => this.tokenRequest(), 5000)
    else return res
  }
  async initSocket() {
    const promise = await _$.progress.create()
    if (promise.isResolved) return false

    const { host } = _$.splitUrl(__.platform.baseUrl)
    const port = __.device.config("WSOCKET_PORT")

    const self = this
    self.socket = new WebSocket(`ws://${host}:${port}`)

    self.socket.onopen = function() {
      promise.resolve()
    }
    self.socket.onerror = function() {
      setTimeout(self.connectWebSocket, self.reconnectInterval)
    }

    self.socket.onclose = function() {
      setTimeout(self.connectWebSocket, self.reconnectInterval)
    }

    return promise.done
  }
}

export default Api
